import React from 'react'
import { Typography } from '@mui/material'
import aws from '../../images/aws.png'
import { useLabraAiAwsIntegrationBadgeStyles } from './LabraAiAwsIntegrationBadge.styles'

type LabraAiAwsIntegrationBadgeProps = {
  className?: string
}

export const LabraAiAwsIntegrationBadge = ({
  className,
}: LabraAiAwsIntegrationBadgeProps) => {
  const { classes, cx } = useLabraAiAwsIntegrationBadgeStyles()

  return (
    <div
      className={cx(classes.root, className)}
      data-testid="labra-ai-aws-integration-badge"
    >
      <Typography component="span" className={classes.label}>
        Integrated with
      </Typography>
      <img className={classes.logo} src={aws} alt="AWS" />
    </div>
  )
}
